import React from 'react';
import { Provider } from 'react-redux';
import { configureStore as store, persistor } from '../redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import ReactGA from 'react-ga';

const TRACKING_ID = process.env.REACT_APP_GA || 'UA-163565237-1';
ReactGA.initialize(TRACKING_ID);

const App: React.FC = ({ children }: any) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);

App.displayName = 'SWXApp';

export default App;
